import React from 'react';
import { TipsMapType } from '..';
import { CONTACT_NAME, CONTACT_EMAIL } from '@op/constants';

import hatchetIcon from '@op/assets/svg/hatchet.svg';

export const influencerSumTipsText: TipsMapType = {
  en: (
    <>
      The View and Engagement metrics on the "Sum Influencer" page do not
      include streaming data. To view performance metrics of streaming, please
      switch to the "Streaming Influencers" tab.
    </>
  ),
  zh: (
    <>
      网红汇总页中的观看量和互动量指标不包含对直播数据的统计，如需查看直播相关表现数据，请切换至“直播类网红Tab”。
    </>
  ),
};

export const influencerBrandListSumTipsText: TipsMapType = {
  en: (
    <>
      Non-streaming influencers are the sum of "Video influencers" and "Post
      influencers". To view the list of "Streaming influencers", please switch
      to the "Streaming influencers" Tab.
    </>
  ),
  zh: (
    <>
      非直播类网红为“视频类网红”及“图文类网红”的加总。因为“直播类网红”的核心指标不同，若要查看“直播类网红”相关列表，请向右切换至“直播类网红”。
    </>
  ),
};

export const influencerPartneredTipsText: TipsMapType = {
  en: `A Partnered influencer is one who posts with @official account, links to the official website/game store, or hashtags containing cooperative tags.If you find any tagging incorrect or want to supplement the partnered list, feel free to contact ${CONTACT_NAME}.`,
  zh: `合作网红是指发帖信息有@官方账号、附带官网/游戏商店链接或者hashtag包含合作标签的网红。如果您发觉合作网红识别不准，或者想要补充合作网红名单，请联系${CONTACT_NAME}。`,
};

export const influencerStreamingInfluencerTipsText: TipsMapType = {
  en: (
    <>
      Streaming influencers: Sum of influencers on Twitch, Youtube and Facebook.
      Data source comes from
      <img
        style={{ verticalAlign: 'middle', margin: '0 5px' }}
        src={hatchetIcon}
      ></img>
      Stream Hatchet.
    </>
  ),
  zh: (
    <>
      直播类网红：汇总 Twitch，Youtube 和 Facebook 平台的网红。数据来源于
      <img
        style={{ verticalAlign: 'middle', margin: '0 5px' }}
        src={hatchetIcon}
      ></img>
      Stream Hatchet 平台。
    </>
  ),
};

export const influencerAllPublicationsTipsText: TipsMapType = {
  en: 'Statistics are only collected on the content published by Influencer on this game, excluding content not related to the game.',
  zh: '仅根据网红针对本游戏的发布内容进行统计，不包括非本游戏相关内容。',
};

export const influencerAllEngagementTipsText: TipsMapType = {
  en: 'All Engagements: the number of Engagements of videos and posts posted by the Influencers, including likes, dislikes, comments, and shares.',
  zh: '总互动量：该网红发布的所有视频贴和图文贴的互动量，包括点赞、点踩、评论、转发。',
};

export const influencerAllViewsTipsText: TipsMapType = {
  en: 'Statistics are only collected on the content (Videos and posts) published by Influencer on this game, excluding content not related to the game.',
  zh: '仅根据 Influencer 针对本游戏的发布内容（视频和文字帖）进行统计，不包括非本游戏相关内容。',
};

export const influencerVideoViewsTipsText: TipsMapType = {
  en: 'Statistics are only collected on the videos published by Influencer on this game, excluding content not related to the game.',
  zh: '仅根据 Influencer 针对本游戏的视频内容进行统计，不包括非本游戏相关内容。',
};

export const influencerTop50FollowersTipsText: TipsMapType = {
  en: 'The average number of followers for the top 50 influencers across all platforms; if there are fewer than 50 influencers, calculate the average based on all influencers available.',
  zh: '跨所有平台排名前 50 的网红的粉丝量平均值；如果网红数量不到50，则计算所有网红的粉丝量平均值。',
};

export const influencerVideoTipsText: TipsMapType = {
  en: 'Statistics are only collected on the videos published by Influencer on this game, excluding content not related to the game.',
  zh: '仅根据 Influencer 针对本游戏的视频内容进行统计，不包括非本游戏相关内容。',
};

export const brandCreatorAllViewsTipsText: TipsMapType = {
  en: 'The total number of views for the videos and image-and-text posts published by this influencer within the selected time range.',
  zh: '该网红在所选时间范围内发布的视频贴和图文帖的总观看量',
};

export const brandCreatorAllLikesTipsText: TipsMapType = {
  en: 'The total number of likes on the videos and image-and-text posts published by this influencer within the selected time range.',
  zh: '该网红在所选时间范围内发布的视频贴和图文帖的总点赞量',
};

export const brandCreatorAllCommentsTipsText: TipsMapType = {
  en: 'The total number of comments on the videos and image-and-text posts published by this influencer within the selected time range.',
  zh: '该网红在所选时间范围内发布的视频贴和图文帖的总评论量',
};


export const influencerProfileTipsText: TipsMapType = {
  en: (
    <>
      Influencers are classified into different tiers according to their number
      of followers：
      <br />
      Common Publisher(0-1k)
      <br />
      Nano Influencer(1-10k) <br />
      Micro Influencer(10k-50k)
      <br />
      Mid-Tier Influencer(50k-500k)
      <br />
      Macro Influencer(500k-1M)
      <br />
      Mega Influencer(1M+)
    </>
  ),
  zh: (
    <>
      网红根据粉丝数分类，分类规则如下：
      <br />
      普通发帖用户(0K ~ 1K)
      <br />
      纳米网红(1K ~ 10K) <br />
      微网红(10k ~ 50k)
      <br />
      小网红(50k ~ 500k)
      <br />
      中网红(500k ~ 1M)
      <br />
      大型网红(1M+)
    </>
  ),
};

export const influencerTotalSessionsTipsText: TipsMapType = {
  en: 'Statistics are only collected on the streaming sessions published by Influencer on this game, excluding content not related to the game.',
  zh: '仅根据 Influencer 针对本游戏的发布内容进行统计，不包括非本游戏相关内容。',
};

export const influencerVideoInfluencerTipsText: TipsMapType = {
  en: (
    <>
      Video influencers： Influencers who have posted videos in the selected
      time range on each platform
    </>
  ),
  zh: <>视频网红：所选时间范围有过发过视频贴的网红</>,
};

export const influencerPostInfluencerTipsText: TipsMapType = {
  en: (
    <>
      Post Influencers： Influencers who have posted text/image posts in the
      selected time range on each platform
    </>
  ),
  zh: <>图文类网红：所选时间范围有发过图文帖的网红</>,
};

export const influencerSumInfluencerTipsText: TipsMapType = {
  en: (
    <>
      Influencers: Influencers who have posted videos, text posts, or have
      streamed in the selected time range on each platform.
    </>
  ),
  zh: <> 网红：所选时间范围有过发过视频、图文帖、以及直播的网红</>,
};

export const influencerPostPublicationsTipsText: TipsMapType = {
  en: 'Statistics are only collected on the posts published by Influencer on this game, excluding content not related to the game.',
  zh: '仅根据 Influencer 针对本游戏的图文贴内容进行统计，不包括非本游戏相关内容。',
};

// export const influencerPostViewsTipsText: TipsMapType = {
//   en: 'Statistics are only collected on the content (posts) published by Influencer on this game, excluding content not related to the game.',
//   zh: '仅根据 Influencer 针对本游戏的发布内容（图文帖）进行统计，不包括非本游戏相关内容。',
// };

export const influencerPostEngagementTipsText: TipsMapType = {
  en: 'Post Engagements: the number of Engagements of posts, including likes, comments, and shares.',
  zh: '图文贴互动量：所有图文贴的互动量，包括点赞、评论、转发。',
};

export const influencerFollowersTipsText: TipsMapType = {
  en: 'Followers source of each platform: Youtube is taken from Subscribe, and other platforms are taken from Followers.',
  zh: '各平台的 Followers 取值：Youtube 取自 Subscribe，其他平台取自Followers。',
};

export const influencerTableTagsTipsText: TipsMapType = {
  en: (
    <>
      Partnered influencers: influencers whose posts contain @official account,
      official website/game store link, or hashtag containing cooperative label
      <br />
      Active influencers: influencers who have posted at least once a week in
      the past three weeks as of the selected time
      <br />
      Potential influencers: influencers whose average Engagement Rate of posts
      in the selected time period is higher than the standard, such as the
      standards of Youtube/Twitter/Instagram channels are 2.5%, 0.3%, and 2.5%
      respectively; and posts with Views/Followers&gt;1.5, Followers&gt;1000
    </>
  ),
  zh: (
    <>
      合作网红：发帖信息有@官方账号、附带官网/游戏商店链接或者hashtag包含合作标签的网红
      <br />
      活跃网红：截至选定时间，过去三周每周都至少有一次发帖的网红
      <br />
      潜力网红：选定时间区间内网红所发帖子的Engagement
      Rate平均值高于标准，如Youtube/Twitter/Instagram渠道的标准分别为2.5%，0.3%，2.5%，且所发帖子Views/Followers&gt;1.5，Followers&gt;1000
    </>
  ),
};

export const influencerViewPerVideoTipsText: TipsMapType = {
  en: 'The Statistics represent the average views per video for game-related content published by this influencer.',
  zh: '统计数据为该influencer发布的此游戏相关内容（视频）条均播放量。',
};

export const influencerViewPerPostTipsText: TipsMapType = {
  en: 'The Statistics represent the average views per post for game-related content published by this influencer.',
  zh: '统计数据为该influencer发布的此游戏相关内容（图文帖）条均播放量。',
};

export const influencerViewPerSumTipsText: TipsMapType = {
  en: 'The Statistics represent the average views per publication (videos and posts) for game-related content published by this influencer.',
  zh: '统计数据为该influencer发布的此游戏相关内容（视频和图文帖）条均播放量。',
};

export const filteredInfluencerTipsText: TipsMapType = {
  en: (
    <>
      DataBrain assigns corresponding segmentation tags to influencers based on
      the games they play and the game affinity of those games:
      <br />
      <b>Core: Brand-related</b> - Influencer's affinity with the brand's own
      game is 50% or higher.
      <br />
      <b>Sub-core: Competitor-related</b> - Influencer's affinity with the
      brand's competitor is 50% or higher.
      <br />
      <b>Genre: Genre-related</b> - Influencer's affinity with games in the same
      genre as the brand is 50% or higher.
      <br />
      <b>Variety</b> - Influencers who play various games and perform
      outstandingly.
      <br />
      The competing games are sourced from the competitors in the DataBrain
      configuration list, while the genre games are derived from the category's
      key games. If you need to modify either of these lists, please contact
      {CONTACT_NAME}.
    </>
  ),
  zh: (
    <>
      DataBrain根据网红所玩的游戏及该款游戏的亲密度，给网红打上对应的分层标签：
      <br />
      <b>核心：品牌相关</b> - 网红本品牌游戏的亲密度在50%及以上
      <br />
      <b>次核心：竞品相关</b> - 网红本品牌游戏相关的竞品游戏的亲密度在50%及以上
      <br />
      <b>品类：品类相关</b> - 网红本品牌游戏相关的品类游戏的亲密度在50%及以上
      <br />
      <b>综合类玩家</b> - 各类游戏都有涉及且表现出众的网红
      <br />
      其中竞品游戏列表来源于游戏配置时填入的竞品，品类游戏列表来源于品类重点游戏列表，若要修改以上两个列表，请联系{CONTACT_NAME}。
    </>
  ),
};

export const influencerSegmentationAndTagTableTips: TipsMapType = {
  en: (
    <>
      <b>Partnered influencers</b>: influencers whose posts contain @official
      account, official website/game store link, hashtag containing cooperative
      label, or paid tags in their YouTube videos.
      <br />
      Meanwhile, DataBrain assigns corresponding segmentation tags to
      influencers based on the games they play and their affinity with those
      games:
      <br />
      <b>Core: Brand-related</b> - Influencer's affinity with the brand's own
      game is 50% or higher.
      <br />
      <b>Sub-core: Competitor-related</b> - Influencer's affinity with the
      brand's competitor is 50% or higher.
      <br />
      <b>Genre: Genre-related</b> - Influencer's affinity with games in the same
      genre as the brand is 50% or higher.
      <br />
      <b>Variety</b> - Influencers who play various games and perform
      outstandingly.
    </>
  ),
  zh: (
    <>
      <b>合作网红</b>
      ：发帖信息有@官方账号、附带官网/游戏商店链接、hashtag包含合作标签或者Youtube视频中有付费标签的网红。
      <br />
      同时，DataBrain根据网红所玩游戏及游戏的亲密度，给网红打上对应的分层标签：
      <br />
      <b>核心：品牌相关</b> - 网红本品牌游戏的亲密度在50%及以上
      <br />
      <b>次核心：竞品相关</b> - 网红本品牌游戏相关竞品游戏的亲密度在50%及以上
      <br />
      <b>品类：品类相关</b> - 网红本品牌游戏相关品类游戏的亲密度在50%及以上
      <br />
      <b>综合类玩家</b> - 各类游戏都有涉及且表现出众的网红
    </>
  ),
};

export const influencerBrandAffinityTipsText: TipsMapType = {
  en: `Percentage of content related to the brand's game compared to the total content created by the creators (In the selected time range)`,
  zh: '选定的本游戏相关的内容占网红创造的内容总数的百分比（在所选的时间区间内）',
};

export const influencerGamesCoveredTipsText: TipsMapType = {
  en: `All the games the influencers played or covered in their posts (In the selected time range). `,
  zh: '网红在帖子里游玩或包含的所有游戏（在所选的时间区间内）。',
};

export const influencerGrowthOfFollowersTipsText: TipsMapType = {
  en: `The difference is obtained by subtracting the data of the previous interval from the current interval. Negative numbers representing declines and positive numbers representing increases.`,
  zh: '通过本期区间减去上期区间的数据获得差值，负数代表粉丝量下降，正数代表粉丝量上涨。',
};

export const influencerTotalPublicationsTipsText: TipsMapType = {
  en: `The number of the influencer's total publications in the selected time range.`,
  zh: '网红在所选的时间区间内总发帖量',
};
export const influencerAvgViewTipsText: TipsMapType = {
  en: `The average number of views of the influencer's total posts in the selected time range.`,
  zh: '网红在所选的时间区间内所有帖子的平均观看量',
};

export const influencerAvgEngagementRateTipsText: TipsMapType = {
  en: (
    <>
      The average engagement rate (Engagement / Potential Impressions) of the
      influencer's total posts in the selected time range.
      <br />
      Engagement = Likes + Dislike + Comments + Share
    </>
  ),
  zh: (
    <>
      网红在所选时间区间内所有帖子的平均互动率（互动量/曝光量）
      <br />
      互动量 = 点赞 + 点踩 + 评论 + 分享
    </>
  ),
};

export const influencerBrandRelatedAvgViewsTipsText: TipsMapType = {
  en: `The average number of views of the influencer's brand-related posts in the selected time range.`,
  zh: '网红在所选的时间区间内本品牌游戏帖子的平均观看量',
};

export const influencerBrandRelatedPublicationsTipsText: TipsMapType = {
  en: `The average number of the influencer's brand-related posts in the selected time range.`,
  zh: '网红在所选的时间区间内本品牌游戏相关的发帖量',
};

export const influencerListTipsText: TipsMapType = {
  en: `The influencer data collection for this page started in May 2024. If you need historical data, please contact ${CONTACT_NAME}.`,
  zh: `网红数据从2024年5月开始抓取，如有回溯需求，请联系${CONTACT_NAME}`,
};

export const influencerCoreTagsTipsText: TipsMapType = {
  en: (
    <>
      Core:
      <br />
      The affinity for a particular game is 50% or higher,
      <br />
      meaning that more than half of the influencer’s
      <br />
      historical publications are related to that game.
    </>
  ),
  zh: (
    <>
      核心:
      <br />
      该网红历史以来一半以上的视频都和该游戏相关，
      <br />
      某款游戏的亲密度大于等于50%
    </>
  ),
};

export const influencerMultiGamerTagsTipsText: TipsMapType = {
  en: (
    <>
      Multi-gamer:
      <br />
      The influencer has played three or more games historically,
      <br />
      and the game affinity for each is less than 50%.
    </>
  ),
  zh: (
    <>
      多游戏网红:
      <br />
      网红历史以来播放过三款及以上的游戏，
      <br />
      并且游戏亲密度都小于50%
    </>
  ),
};

export const influencerMonthlyReturningTagsTipsText: TipsMapType = {
  en: (
    <>
      Monthly Returning: The influencer posted during the statistical period,
      but did not post in the month before the statistical period.
    </>
  ),
  zh: <>月度回流：该网红统计周期内有发帖，但统计周期前一个月内未发帖</>,
};

export const influencerQuarterlyReturningTagsTipsText: TipsMapType = {
  en: (
    <>
      Quarterly Returning: The influencer posted during the statistical period,
      but did not post in the three months before the statistical period.
    </>
  ),
  zh: <>季度回流：该网红统计周期内有发帖，但统计周期前三个月内未发帖</>,
};

export const influencerCommonTipsText: TipsMapType = {
  en: (
    <>
      The current page's live streaming data only supports detailed statistics
      for the top 100 live streaming channels on a daily basis. For any
      expansion requests, please contact {CONTACT_EMAIL}.
    </>
  ),
  zh: (
    <>
      当前页面直播数据，仅支持每日Top100
      直播频道详情数据统计，如需拓展，请联系{CONTACT_EMAIL}
    </>
  ),
};

export const influencerViewsLossRateTipsText: TipsMapType = {
  en: `Brand-Related Views Loss Rate= (total post average views - brand-related average views)/total post average views*100%`,
  zh: `品牌观看量折损率=(总发帖平均观看量-品牌游戏平均观看量）/总发帖平均观看量*100%`
};
